function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Quadrant from './quadrant';
import { cmQuadrantSelector } from '../../redux/reducers/inferences';
import { selectInference } from '../../redux/actions/inferences';
import './ConfusionMatrix.css';
import { ToolTip } from '../../components/Tooltip';
import _ from "lodash";

var ConfusionMatrix = function ConfusionMatrix() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      scores = _useSelector.scores,
      inferences = _useSelector.inferences,
      game = _useSelector.game;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      requestStatus = _useState2[0],
      setRequestStatus = _useState2[1];

  var dispatch = useDispatch();

  var selectInferenceProp = function selectInferenceProp(inference) {
    return dispatch(selectInference(inference));
  };

  var tooltipRef = useRef(null);
  useEffect(function () {
    if (tooltipRef.current.isVisible()) {
      tooltipRef.current.hide();
    }
  }, [scores]);
  return /*#__PURE__*/React.createElement("div", {
    className: "confusion-matrix panel--round"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel--round__header"
  }, /*#__PURE__*/React.createElement("b", null, "Last Batch Results")), /*#__PURE__*/React.createElement("div", {
    className: "panel--round__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container flex-justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "confusion-matrix__top__axis flex-column-container flex-justify-evenly"
  }, /*#__PURE__*/React.createElement("b", {
    className: "text-center"
  }, "Actual Part Quality"), /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container flex-justify-space-around text-center"
  }, /*#__PURE__*/React.createElement("label", null, "OK"), /*#__PURE__*/React.createElement("label", null, "DEFECT")))), /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "confusion-matrix__left__axis flex-row-container flex-justify-evenly"
  }, /*#__PURE__*/React.createElement("b", {
    className: "no-margin vertical-lr text-center"
  }, "Your Model Said:"), /*#__PURE__*/React.createElement("div", {
    className: "flex-column-container flex-justify-space-around"
  }, /*#__PURE__*/React.createElement("label", {
    className: "vertical-lr text-center"
  }, "OK"), /*#__PURE__*/React.createElement("label", {
    className: "vertical-lr text-center"
  }, "DEFECT"))), /*#__PURE__*/React.createElement("div", {
    className: "confusion-matrix__quadrant__container flex-row-container flex-wrap"
  }, /*#__PURE__*/React.createElement(Quadrant, {
    inferences: cmQuadrantSelector(inferences, false, false),
    label: "Correctly Classified",
    selectInference: selectInferenceProp,
    color: "palegreen",
    tooltipRef: tooltipRef
  }), /*#__PURE__*/React.createElement(Quadrant, {
    inferences: cmQuadrantSelector(inferences, true, false),
    label: "Misclassified",
    selectInference: selectInferenceProp,
    color: "salmon",
    tooltipRef: tooltipRef
  }), ' ', /*#__PURE__*/React.createElement(Quadrant, {
    inferences: cmQuadrantSelector(inferences, false, true),
    label: "Misclassified",
    selectInference: selectInferenceProp,
    color: "salmon",
    tooltipRef: tooltipRef
  }), /*#__PURE__*/React.createElement(Quadrant, {
    inferences: cmQuadrantSelector(inferences, true, true),
    label: "Correctly Classified",
    selectInference: selectInferenceProp,
    color: "palegreen",
    tooltipRef: tooltipRef
  })), /*#__PURE__*/React.createElement(ToolTip, {
    ref: tooltipRef,
    dynamicPointer: true
  }))));
};

export default ConfusionMatrix;